const openImagePreview = (url) => {
  const popup = window.open("", "_blank")
  if (!popup) return

  popup.document.write(`<!DOCTYPE html>
<html lang="fr">
<head>
  <meta charset="utf-8">
  <title>Aperçu</title>
  <style>
    html, body { margin: 0; min-height: 100%; background: #111; }
    body { display: flex; align-items: center; justify-content: center; }
    img { max-width: 100vw; max-height: 100vh; object-fit: contain; }
  </style>
</head>
<body>
  <img src="${url.replace(/"/g, "&quot;")}" alt="Aperçu">
</body>
</html>`)
  popup.document.close()
}

const initBackofficeImagePreview = () => {
  document.querySelectorAll("[data-image-preview]").forEach((link) => {
    if (link.dataset.previewBound === "true") return
    link.dataset.previewBound = "true"

    link.addEventListener("click", (event) => {
      event.preventDefault()
      const url = link.getAttribute("data-image-preview")
      if (url) openImagePreview(url)
    })
  })
}

export { initBackofficeImagePreview }
